import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

type UserProfileType = {
  branches: number[];
  bio: string;
  must_change_password: boolean;
  phone_number: string;
  photo: string;
  states: number[];
  user_id: number;
  user_profile_id: number;
  username: string;
  zones: number[];
  is_idealtime: boolean;
};

type UserPermissionsContextType = {
  userPermissions: any[];
  setUserPermissions: React.Dispatch<React.SetStateAction<any[]>>;
  userData: any;
  setUserData: React.Dispatch<React.SetStateAction<any>>;
  webApi: string;
  userProfile: UserProfileType;
  setUserProfile: React.Dispatch<React.SetStateAction<UserProfileType>>;
  userAbilities: any[];
  setUserAbilities: React.Dispatch<React.SetStateAction<any[]>>;
};

const UserPermissionsContext = createContext<
  UserPermissionsContextType | undefined
>(undefined);

interface UserPermissionsProviderProps {
  children: ReactNode;
}

export const UserPermissionsProvider: React.FC<
  UserPermissionsProviderProps
> = ({ children }) => {
  const [userPermissions, setUserPermissions] = useState<any[]>(() => {
    const savedPermissions = localStorage.getItem("userPermissions");
    return savedPermissions ? JSON.parse(savedPermissions) : [];
  });

  const [userData, setUserData] = useState<any>(() => {
    const savedUserData = localStorage.getItem("userData");
    return savedUserData ? JSON.parse(savedUserData) : null;
  });

  const [userProfile, setUserProfile] = useState<UserProfileType>(() => {
    const savedUserProfile = localStorage.getItem("userProfile");
    return savedUserProfile
      ? JSON.parse(savedUserProfile)
      : {
          branches: [],
          bio: "",
          must_change_password: false,
          phone_number: "",
          photo: "",
          states: [],
          user_id: 0,
          user_profile_id: 0,
          username: "",
          zones: [],
        };
  });

  const [userAbilities, setUserAbilities] = useState<any[]>(() => {
    const savedAbilities = localStorage.getItem("userAbilities");
    return savedAbilities ? JSON.parse(savedAbilities) : [];
  });

  const webApi = "https://app.srichaitanyacrm.com";

  // const webApi = "http://10.30.30.122:8000/";
  
  // const webApi = "http://202.65.141.178:8025/";

  // const webApi = "http://10.10.41.166:8008/";123

  
  useEffect(() => {
    try {
      localStorage.setItem("userPermissions", JSON.stringify(userPermissions));
    } catch (error) {
      console.error("Error saving userPermissions to localStorage:", error);
    }
  }, [userPermissions]);

  useEffect(() => {
    try {
      localStorage.setItem("userData", JSON.stringify(userData));
    } catch (error) {
      console.error("Error saving userData to localStorage:", error);
    }
  }, [userData]);

  useEffect(() => {
    try {
      localStorage.setItem("userProfile", JSON.stringify(userProfile));
    } catch (error) {
      console.error("Error saving userProfile to localStorage:", error);
    }
  }, [userProfile]);

  useEffect(() => {
    try {
      localStorage.setItem("userAbilities", JSON.stringify(userAbilities));
    } catch (error) {
      console.error("Error saving userAbilities to localStorage:", error);
    }
  }, [userAbilities]);

  return (
    <UserPermissionsContext.Provider
      value={{
        userPermissions,
        setUserPermissions,
        userData,
        setUserData,
        webApi,
        userProfile,
        setUserProfile,
        userAbilities,
        setUserAbilities,
      }}
    >
      {children}
    </UserPermissionsContext.Provider>
  );
};

export const useUserPermissions = () => {
  const context = useContext(UserPermissionsContext);
  if (!context) {
    throw new Error(
      "useUserPermissions must be used within a UserPermissionsProvider"
    );
  }
  return context;
};
